import { render, staticRenderFns } from "./Artista.vue?vue&type=template&id=fcac91cc&"
import script from "./Artista.vue?vue&type=script&lang=js&"
export * from "./Artista.vue?vue&type=script&lang=js&"
import style0 from "./Artista.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports